import styled from 'styled-components';

export const ContLayoutResult = styled.div`
  width: 100%;
  height: auto;
  background-color: #FBFFFF;
`
